angular
    .module('util.MapModule', []);